import { Privileges } from '@/auth/enum/auth.enum';
import { AuthService } from '@/auth/service/auth.service';
import { Component } from '@angular/core';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {

  constructor(private auth: AuthService) { }

  get showPersonalLicenseRequest(): boolean {
    const acceptedPrivileges: Privileges[] = [
      'LICENSE REQUEST PERSONAL_CONTRACTOR',
      'LICENSE REQUEST PERSONAL_EMPLOYEE',
    ];

    return acceptedPrivileges.some((privilege) => this.auth.userHavePrivilege(privilege));
  }

  get showThirdPersonRequest(): boolean {
    const acceptedPrivileges: Privileges[] = [
      'LICENSE REQUEST THIRD_CONTRACTOR',
      'LICENSE REQUEST THIRD_EMPLOYEE',
    ];

    return acceptedPrivileges.some((privilege) => this.auth.userHavePrivilege(privilege));
  }
}
